<template>
  <div class="RwvContentImageEdit">
    <b-form-group>
      <RwvImageCropper
        @cropImage="cropImage"
        @deleteImage="deleteImage"
        :srcImage="image.data"
        :targetFolder="postSlug"
        :index="index">
        </RwvImageCropper>

    </b-form-group>

    <b-form-group>
      <input
        type="checkbox"
        class="form-check-input"
        :id="'input-showTitle-'+index"
        v-model="image.showTitle">

      <label
        class="form-check-label"
        :for="'input-showTitle-'+index">
        Titel anzeigen
      </label>
    </b-form-group>

    <b-form-group
      :id="'input-group-showTitle-'+index"
      :label-for="'input-showTitle-'+index"
      v-b-tooltip.hover
      title="Titel">

      <b-form-input
        :id="'input-showTitle-'+index"
        v-model="image.title"
        placeholder="Titel">
      </b-form-input>
    </b-form-group>

    <b-form-group>
      <input
        type="checkbox"
        class="form-check-input"
        :id="'input-showDescription-'+index"
        v-model="image.showDescription">

      <label
        class="form-check-label"
        :for="'input-showDescription-'+index">
        Beschreibung anzeigen
      </label>
    </b-form-group>

    <b-form-group
      :id="'input-group-description-'+index"
      v-if="image.showDescription"
      :label-for="'input-description-'+index"
      v-b-tooltip.hover
      title="Beschreibung">

      <b-form-input
        :id="'input-description-'+index"
        v-model="image.description"
        placeholder="Beschreibung">
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import RwvImageCropper from "@/components/ImageCropper";

export default {
  name: "RwvContentImageEdit",
  props: {
    image: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      required: true
    },
    postSlug: {
      type: String
    }
  },
  components: {
    RwvImageCropper
  },
  methods: {
    // ToDo: Implement Upload Logic one step down
    cropImage(croppedImage) {
      this.image.data = croppedImage
    },
    deleteImage() {
      this.image.data = ""
    },
    deleteImageAWS() {
      this.image.url = croppedImage
    },
    uploadImageAWS() {
      this.image.url = croppedImage
    },
    emitChanged() {
      this.$emit("changed", this.image)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
